import type { LucideIcon } from 'lucide-react'
import { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface EmptyStateProps {
  title: string
  description?: string
  ctaButton?: ReactNode
  /** Ikona v jemném kruhu nad nadpisem (lucide-react) */
  icon?: LucideIcon
  /** Kompaktní varianta bez rámečku, např. do popoveru */
  compact?: boolean
  className?: string
}

export const EmptyState = ({ title, description, ctaButton, icon: Icon, compact = false, className }: EmptyStateProps) => {
  return (
    <div
      className={cn(
        'grid place-content-center place-items-center gap-3 text-center',
        compact ? 'px-6 py-8' : 'rounded-lg border border-dashed px-8 py-14',
        className,
      )}
    >
      {Icon && (
        <span className="relative mb-1 grid size-12 place-items-center rounded-full bg-brand-soft text-brand-strong">
          <span className="absolute inset-0 rounded-full ring-8 ring-brand-soft/50" aria-hidden />
          <Icon className="relative size-5" strokeWidth={1.75} />
        </span>
      )}
      <h2 className="text-base font-medium">{title}</h2>

      {description && <p className="max-w-sm text-sm text-muted-foreground text-pretty">{description}</p>}

      {ctaButton}
    </div>
  )
}
